import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Links from 'components/Link';
import s from '../PointsTable/PointsTable.scss';
import CricketRankingList from './CricketRankingList';
// import PointsTableList from './PointsTableList';

const CricketRanking = props => {
  const {
    isWapView,
    target,
    moreText,
    hideTabs = '',
    cricketRanking = null,
    onGroupTabsChange,
    totalRankings,
    path,
    className,
  } = props;

  // eslint-disable-next-line prefer-destructuring
  let currentTab = props.currentTab;
  let groupData;
  groupData = props.groupData;
  groupData = [
    ...groupData.filter(item => item.is_active),
    ...groupData.filter(item => !item.is_active),
  ];

  // eslint-disable-next-line array-callback-return
  groupData.map(item => {
    if (
      currentTab === 'Playoff' &&
      (item.is_active === true || item.is_active === 'true')
    ) {
      currentTab = item.name;
    }
  });

  const [activeTab, setActiveTab] = useState(currentTab);

  const tabHandler = dataObj => {
    setActiveTab(dataObj.name);
    onGroupTabsChange(dataObj);
  };

  const totalRankingsToShow = parseInt(totalRankings, 10);

  useEffect(
    () => {
      if (currentTab === 'Team') {
        setActiveTab('Teams');
      } else {
        setActiveTab(currentTab);
      }
    },
    [currentTab],
  );

  return (
    <div className={`${s.pointstable} ${className}`}>
      {!hideTabs && (
        <div className={s.tabwapWrap}>
          <div className={s.tabwap}>
            {groupData &&
              Array.isArray(groupData) &&
              groupData.map(tabData => (
                <>
                  {tabData.name &&
                    tabData.link &&
                    !tabData.path && (
                      <>
                        <div
                          className={`${s.tab} ${
                            activeTab === tabData.name ? s.active : ''
                          }`}
                          onClick={() => {
                            tabHandler(tabData);
                          }}
                        >
                          <span>{tabData.name}</span>
                          {tabData &&
                            tabData.promptCount && (
                              <span className={s.promptCount}>
                                {tabData.promptCount}
                              </span>
                            )}
                        </div>
                      </>
                    )}
                  {tabData.name &&
                    tabData.link &&
                    tabData.path && (
                      <>
                        <div
                          className={`${s.tab} ${
                            activeTab === tabData.name ? s.active : ''
                          }`}
                        >
                          <Links className="" to={tabData.path}>
                            <span>{tabData.name}</span>
                          </Links>
                          {/* <span>{tabData.name}</span> */}
                          {tabData &&
                            tabData.promptCount && (
                              <span className={s.promptCount}>
                                {tabData.promptCount}
                              </span>
                            )}
                        </div>
                      </>
                    )}
                </>
              ))}
          </div>
        </div>
      )}

      {cricketRanking &&
        cricketRanking?.['bat-rank'] && (
          <CricketRankingList
            isWapView={isWapView}
            cricketRanking={cricketRanking}
            totalRankings={totalRankings}
          />
        )}

      {totalRankingsToShow === 10 &&
        isWapView &&
        path && (
          <div className={s.morePointTable}>
            <a href={path} target={target}>
              {moreText}
            </a>
          </div>
        )}
    </div>
  );
};

CricketRanking.propTypes = {
  groupData: PropTypes.arrayOf({}),
  cricketRanking: PropTypes.arrayOf({}),
  onGroupTabsChange: PropTypes.func.isRequired,
  currentTab: PropTypes.string,
  isWapView: PropTypes.bool,
  hideTabs: PropTypes.string,
  target: PropTypes.string,
  moreText: PropTypes.string,
  totalRankings: PropTypes.number,
  path: PropTypes.string,
  className: PropTypes.string,
};
CricketRanking.defaultProps = {
  cricketRanking: [],
  groupData: [],
  currentTab: '',
  isWapView: false,
  hideTabs: '',
  target: '',
  moreText: '',
  totalRankings: 10,
  path: '',
  className: '',
};

export default React.memo(CricketRanking);
